import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    setTeacherCountryAffiliation as SetCountryData,
    setTeacherCountryAffiliationVariables as SetCountryVariables,
} from "./__graphql-types__/setTeacherCountryAffiliation.ts";
import type {
    setTeacherSchoolAffiliation as SetSchoolData,
    setTeacherSchoolAffiliationVariables as SetSchoolVariables,
} from "./__graphql-types__/setTeacherSchoolAffiliation.ts";

export const TEACHER_COUNTRY_AFFILIATION_MUTATION: GqlOperation<
    SetCountryData,
    SetCountryVariables
> = gqlOp(gql`
    mutation setTeacherCountryAffiliation($countryCode: String!) {
        userSettingsSetAffiliationCountryCode(countryCode: $countryCode) {
            error {
                code
            }
        }
    }
`);

export const TEACHER_SCHOOL_AFFILIATION_MUTATION: GqlOperation<
    SetSchoolData,
    SetSchoolVariables
> = gqlOp(gql`
    mutation setTeacherSchoolAffiliation(
        $countryCode: String!
        $eduorgKeyId: ID!
    ) {
        userSettingsSetAffiliationCountryCode(countryCode: $countryCode) {
            error {
                code
            }
        }
        setEduorgAffiliation(eduorgKeyId: $eduorgKeyId) {
            user {
                id
                schoolAffiliation {
                    id
                    name
                    postalCode
                    location
                }
                affiliationCountryCode
            }
            error {
                code
            }
        }
    }
`);
